import { useMutation } from "@tanstack/react-query";
import {
  CreatePackageCategoryFormType,
  CreatePackageCategoryResponse,
  CreatePackageSubCategoryFormType,
  CreatePackageSubCategoryResponse,
  DeletePackageCategoryRequestBody,
  DeletePackageCategoryResponse,
  DeletePackageSubCategoryRequestBody,
  DeletePackageSubCategoryResponse,
  EditPackageCategoryFormType,
  EditPackageCategoryResponse,
  EditPackageSubCategoryFormType,
  EditPackageSubCategoryResponse,
} from "./interfaces";

import queryClient from "src/config/reactQuery.config";
import {
  createPackageCategory,
  createPackageSubCategory,
  deletePackageCategory,
  deletePackageSubCategory,
  editPackageCategory,
  editPackageSubCategory,
} from "src/services/PackageCategory.service";

export const useCreatePackageCategory = () => {
  return useMutation<
    CreatePackageCategoryResponse,
    Error,
    CreatePackageCategoryFormType
  >({
    mutationFn: (value) => createPackageCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};

export const useEditPackageCategory = () => {
  return useMutation<
    EditPackageCategoryResponse,
    Error,
    EditPackageCategoryFormType
  >({
    mutationFn: (value) => editPackageCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};

export const useDeletePackageCategory = () => {
  return useMutation<
    DeletePackageCategoryResponse,
    Error,
    DeletePackageCategoryRequestBody
  >({
    mutationFn: (value) => deletePackageCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};

export const useCreatePackageSubCategory = () => {
  return useMutation<
    CreatePackageSubCategoryResponse,
    Error,
    CreatePackageSubCategoryFormType
  >({
    mutationFn: (value) => createPackageSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};

export const useEditPackageSubCategory = () => {
  return useMutation<
    EditPackageSubCategoryResponse,
    Error,
    EditPackageSubCategoryFormType
  >({
    mutationFn: (value) => editPackageSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};

export const useDeletePackageSubCategory = () => {
  return useMutation<
    DeletePackageSubCategoryResponse,
    Error,
    DeletePackageSubCategoryRequestBody
  >({
    mutationFn: (value) => deletePackageSubCategory(value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package-category"] });
    },
  });
};
